var map = {
	"./monster001/monster001.gif": 305058,
	"./monster002/monster002.gif": 420572,
	"./monster003/monster003.gif": 905548,
	"./monster004/monster004.gif": 613703,
	"./monster005/monster005.gif": 120010,
	"./monster006/monster006.gif": 538136,
	"./monster007/monster007.gif": 812993,
	"./monster008/monster008.gif": 575625,
	"./monster009/monster009.gif": 685480
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 274367;